import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { streams } from '../../assets/const'
import Table from '../../components/Table'
import QuestionModal from './QuestionModal/QuestionModal'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { createVariant, deleteVariantQuestion, getQuestionsModal, getQuestionsModalAdd, updateVariant } from '../../actions/applicantQuestionSet'
import { getSchoolYears } from '../../actions/common'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode }) {

  const dispatch = useDispatch()
  const { schoolYears } = useSelector(state => state.common)
  const { variant, questionsModal } = useSelector(state => state.applicantQuestionSet)

  const [questionModal, setQuestionModal] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState([])
  const [tableQuestions, setTableQuestions] = useState([])

  useEffect(() => {
    dispatch(getSchoolYears())
  }, [])

  useEffect(() => {
    setTableQuestions(questionsModal || [])
  }, [questionsModal])


  const openQuestionModal = () => {
    setQuestionModal(data)
    dispatch(getQuestionsModalAdd(data.id, data.level)) && dispatch(getQuestionsModal(data.id))
  }
  const closeQuestionModal = () => {
    setQuestionModal(false)
  }
  const handleCreate = (values) => {
    dispatch(createVariant(values))
    setQuestionModal(false)
  }

  const handleUpdate = (values) => {
    const questionModal = selectedQuestions.map(el => el.id)
    selectedQuestions.length > 0 && dispatch(updateVariant({ ...data, questions: questionModal }, closeModal))
    closeModal()
  }
  const handleUpdateQuestion = (values) => {
    const questionModal = selectedQuestions.map(el => el.id)
    selectedQuestions.length > 0 && dispatch(updateVariant({ ...data, questions: questionModal }, closeQuestionModal))
    closeQuestionModal()
  }

  const handleChangeStudents = (student) => {
    if (typeof student === 'number') setSelectedQuestions((prev) => prev.filter(el => el.id !== student.id))
    else setSelectedQuestions((prev) => !prev.find(el => el.id === student.id) ? [...prev, student] : prev.toSpliced(prev.indexOf(student), 1))
  }

  const {
    values,
    errors,
    touched,
    dirty, // проверяет есть ли изменения
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: !addMode ? handleUpdate : handleCreate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const acceptConfirmation = () => {
    dispatch(deleteVariantQuestion(variant.id, confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (item) => {
    const { id, q_num, name, level, weight, q_type, q_name, block } = item
    return (
      <tr>
        <td>{q_num}</td>
        <td>{name}</td>
        <td>{block}</td>
        <td>{weight}</td>
        <td>{q_type}</td>
        <td>{q_name}</td>
        {/* <td>{xp_pf_a_id}</td>*/}
        <td><i className={styles.trash} onClick={() => setConfirmation({ id, name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          {questionModal &&
            <QuestionModal
              closeModal={closeQuestionModal}
              data={questionModal}
              height={'430px'}
              selectedQuestions={selectedQuestions}
              handleChangeStudents={handleChangeStudents}
              handleUpdateQuestion={handleUpdateQuestion}
            />
          }

          <div className={styles.tabWrapper} >
            {confirmation && (
              <Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
                rejectConfirmation={rejectConfirmation}
              />
            )}
            <div className={styles.inputsColumn}>
              <div className={styles.inputsRow}>
                <Input
                  label='№'
                  type='number'
                  name='number'
                  value={values.number}
                  error={error('number')}
                  onChange={handleChange}
                  style={{ width: '100px' }}
                />
                <Input
                  label='Название варианта теста'
                  name='name'
                  value={values.name}
                  error={error('name')}
                  onChange={handleChange}
                  style={{ width: '770px' }}
                />
              </div>
              <div className={styles.inputsRow}>
                <CustomSelect
                  title='Год набора'
                  valuesName="school_year"
                  options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
                  width='120px'
                  value={values.year_name}
                  setFieldValue={setFieldValue}
                />
                <CustomSelect
                  title='Набор'
                  valuesName="stream"
                  options={streams && arrayForSelect(streams, 'name', 'xp_key')}
                  width='120px'
                  value={values.stream}
                  setFieldValue={setFieldValue}
                />
                <Input
                  label='Класс'
                  type='number'
                  name='level'
                  value={values.level}
                  error={error('level')}
                  onChange={handleChange}
                  style={{ width: '200px' }}
                />
                <Input
                  label='Время выполнения (мин.)'
                  type='number'
                  name='test_time'
                  value={values.test_time}
                  error={error('test_time')}
                  onChange={handleChange}
                  style={{ width: '200px' }}
                />
              </div>
            </div>
            <br />
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>№</th>
                  <th>Дисциплина</th>
                  <th>Блок</th>
                  <th>Сложность</th>
                  <th>Тип</th>
                  <th>Вопрос</th>
                </tr>
              </thead>
              <tbody>
                {variant?.questions?.map(renderLi)}
              </tbody>
            </Table>

          </div>
          <br />
          {data.id &&
            <Button
              style={{ padding: '.5rem 1.5rem' }}
              onClick={openQuestionModal}
            >
              <IoIosAdd size={30} />
              Добавить
            </Button>
          }

        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
